<sc-master-detail [data]="data" [readOnly]="true" [saveAllMode]="true"
  (selectionChanged)="handleSelectionChange($event)" [newStyle]="true" [selection]="[current]">

  <ng-template masterDetailToolbar *ngIf="this.optionsContext.dirty && !loading">
    <div class="actions">
      <sc-flex [vertical]="true" [stretchContent]="true">
        <button class="button" mat-stroked-button [disabled]="!this.optionsContext.dirty || loading" (click)="cancel()">
          {{ 'cancel' | translate:['tmc-yard.action.cancel',
          translationService.language] }}
        </button>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <button class="button" mat-flat-button
          [disabled]="!this.optionsContext.optionsValid || !this.optionsContext.constraintsValid || !this.optionsContext.dirty || loading"
          (click)="save()">
          {{ 'save' | translate:['tmc-yard.action.save',
          translationService.language] }}
        </button>
        <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
      </sc-flex>
    </div>
  </ng-template>

  <!-- <div class="transport-options-administration"> -->

  <!-- <div class="transport-options-administration-layout"> -->

  <!-- <div class="left-column">
        <div class="left-column-layout">

          <div class="actions">

          </div>
          <sc-list-spacer></sc-list-spacer>
          <div class="tab" (click)="setView(0)"
            [ngClass]="{'invalid-marker' : !this.optionsContext.optionsValid, 'active': editMode === 0}">
            {{ 'structure' |
            translate:['tmc-yard.ui.admin.transport-options-administration.view-mode.structure',
            translationService.language] }}
          </div>
          <sc-list-spacer></sc-list-spacer>
          <div class="tab" (click)="setView(1)"
            [ngClass]="{'invalid-marker' : !this.optionsContext.constraintsValid, 'active': editMode == 1}">
            {{ 'constraints' |
            translate:['tmc-yard.ui.admin.transport-options-administration.view-mode.constraints',
            translationService.language] }}
          </div>
          <sc-list-spacer></sc-list-spacer>
          <div class="tab" (click)="setView(2)" [ngClass]="{'active': editMode == 2}">
            {{ 'time frame priority' |
            translate:['tmc-yard.ui.admin.transport-options-administration.view-mode.time-frame-priority',
            translationService.language] }}
          </div>
          <sc-list-spacer></sc-list-spacer>
          <div class="filler"></div>

        </div>
      </div> -->

  <!-- <div class="content-column"> -->

  <sc-padding [fitHeight]="true">
    <sc-scroll-pane>

      <div class="options-view-layout" *ngIf="currentView === 'structure'">
        <div class="dragable-elements">
          <div class="draggable-element" draggable="true" (dragstart)="onAddOptionStart($event)"
            (dragend)="onDragOptionEnd($event)">
            <sc-icon iconClass="fa-plus"></sc-icon>
            {{ 'Option hinzufügen' |
            translate:['app-client.common.action.add',
            translationService.language] }}
          </div>
        </div>

        <app-transport-options-strcuture-editor [addOption]="draggedOption" [optionsContext]="optionsContext"
          class="editor-component">
        </app-transport-options-strcuture-editor>
      </div>

      <app-transport-option-constraints-editor [optionsContext]="optionsContext" class="editor-component"
        *ngIf="currentView === 'constraints'">
      </app-transport-option-constraints-editor>

      <app-time-priority-list [optionsContext]="optionsContext"
        *ngIf="currentView === 'timeframepriority'"></app-time-priority-list>

      <app-service-response [responseMessages]="responseMessages"></app-service-response>

    </sc-scroll-pane>
  </sc-padding>

  <!-- </div> -->

  <!-- </div> -->

  <!-- </div> -->

</sc-master-detail>
